import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";

function LedgerReport() {
    const [data, setData] = useState({});
    const location = useLocation();
    const [dealerId, setDealerId] = useState(null);

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const todayDay = currentDate.getDate();
    const [month, setMonth] = useState(`${currentYear}-${String(currentMonth + 1).padStart(2, '0')}`);
    const [months, setMonths] = useState(`${currentYear}/${String(currentMonth + 1).padStart(2, '0')}`);
    const [daysInMonth, setDaysInMonth] = useState([]);

    const [invoiceTotal, setInvoiceTotal] = useState(0);
    const [paymentTotal, setPaymentTotal] = useState(0);
    const [milkTotal, setMilkTotal] = useState(0);
    const [curdTotal, setCurdTotal] = useState(0);
    const [discountTotal, setDiscountTotal] = useState(0);
    const [schemeTotal, setSchemeTotal] = useState(0);
    const [incentiveTotal, setIncentiveTotal] = useState(0);
    const [transportTotal, setTransportTotal] = useState(0);
    const [marginTotal, setMarginTotal] = useState(0);



    useEffect(() => {
      const maxMonth = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}`;
      setMonth((prevMonth) => prevMonth > maxMonth ? maxMonth : prevMonth);
    },[currentYear, currentMonth]);

    useEffect(() => {
      const getDaysInMonth = (year, month) => {
        const date = new Date(year, month, 0);
        return date.getDate();
      };
      const monthToDisplay = month ? month.split('-')[1] - 1 : currentMonth; // Get month index from "YYYY-MM" format
      const totalDays = getDaysInMonth(currentYear, monthToDisplay + 1);
      const daysArray = [];
      const lastDayToShow = (monthToDisplay === currentMonth) ? todayDay : totalDays;
      for (let i = 1; i <= lastDayToShow; i++) {
        daysArray.push(i);
      }
      setDaysInMonth(daysArray);
    }, [month]);

    const formatFullDate = (day) => {
      const date = new Date(currentYear, parseInt(month.split('-')[1]) - 1, day); // Create a date object for the day
      const options = { year: 'numeric', month: 'long', day: 'numeric' }; // Format options
      return date.toLocaleDateString(undefined, options);
    };
  
    // Format date as "YYYY/MM/DD" (e.g., "2025/03/01")
    const formatShortDate = (day) => {
      const date = new Date(currentYear, parseInt(month.split('-')[1]) - 1, day); // Create a date object for the day
      const year = date.getFullYear();
      const months = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const dayOfMonth = String(date.getDate()).padStart(2, '0');
      return `${year}/${months}/${dayOfMonth}`;
    };  

    const formatShortDatePayment = (day) => {
      const date = new Date(currentYear, parseInt(month.split('-')[1]) - 1, day); // Create a date object for the day
      const year = date.getFullYear();
      const months = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const dayOfMonth = String(date.getDate()).padStart(2, '0');
      return `${year}-${months}-${dayOfMonth}`;
    };  

    
    useEffect(() => {
      const urlParams = new URLSearchParams(location.search);
      const id = urlParams.get("id");
      setDealerId(id);
    }, [location.search]);

    
    useEffect(() => {
        if (dealerId) {
            getData();
        }
    }, [dealerId, month]);

    
    const getData = async () => {
        try {
            const response = await axios.post(
                "https://api.trucoo.in/dealers/report/",
                { dealerId, month },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": "erpTrucoo",
                    },
                }
            );

            //console.log(response.data);
            
            if (response.data.status === "success") {
                setData(response.data.data); 
            } else {
                console.log("Error fetching data");
                setData({});
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData({}); 
        }
    };


    const getInvoiceTotal = (date) => {
      const totalPayment = data?.orderData?.filter(orders => orders.date === date).reduce((acc, order) => acc + parseFloat(order.totalPayment), 0) || 0;
      return totalPayment;
    };

    const getPaymentTotal = (date) => {
      const totalPayment = data?.payments?.filter(payment => payment.date === date).reduce((acc, payment) => acc + parseFloat(payment.amount), 0) || 0;
      return totalPayment;
    };

    const getMilkTotal = (date) => {
        let litters = 0;
        data?.orderData?.forEach(order => {
            if (order.date === date) {
                order.orderDetails?.forEach(item => {
                    if (item.itemUnit === 'L') {
                        litters += ((parseFloat(item.itemGrade) * parseInt(item.qty) * parseInt(item.itemWeight)) / 1000);
                    }
                });
            }
        });
    
        return litters;
    };

    const getCurdTotal = (date) => {
        let litters = 0;
        data?.orderData?.forEach(order => {
            if (order.date === date) {
                order.orderDetails?.forEach(item => {
                    if (item.itemUnit === 'KG') {
                        litters += ((parseFloat(item.itemGrade) * parseInt(item.qty) * parseInt(item.itemWeight)) / 1000);
                    }
                });
            }
        });
    
        return litters;
    };
    

    const getTotal = () => {

      let invoiceTotal = 0;
      let paymentTotal = 0;
      let milkTotal = 0;
      let curdTotal = 0;
      let discount = 0;
      let scheme = 0;

      data?.orderData?.forEach(order => {
        invoiceTotal += parseFloat(order.totalPayment);
      });

      data?.payments?.forEach(payment => {
        paymentTotal += parseFloat(payment.amount);
      });

      data?.orderData?.forEach(order => {

        discount += parseFloat(order.discount);
        scheme += parseFloat(order.schemeValue);

        order.orderDetails?.forEach(item => {
            if (item.itemUnit === 'L') {
                milkTotal += ((parseFloat(item.itemGrade) * parseInt(item.qty) * parseInt(item.itemWeight)) / 1000);
            }
            if (item.itemUnit === 'KG') {
                curdTotal += ((parseFloat(item.itemGrade) * parseInt(item.qty) * parseInt(item.itemWeight)) / 1000);
            }
        });
    });

      setInvoiceTotal(invoiceTotal);
      setPaymentTotal(paymentTotal);
      setMilkTotal(milkTotal);
      setCurdTotal(curdTotal);
      setDiscountTotal(discount);
      setSchemeTotal(scheme);
      setIncentiveTotal(milkTotal*curdTotal*data.incentive);
      setMarginTotal(milkTotal*curdTotal*data.margin);
      setTransportTotal(milkTotal*curdTotal*data.transPort);

    };

    const getDiscount = (date) => {
        const discount = data?.orderData?.filter(orders => orders.date === date).reduce((acc, order) => acc + parseFloat(order.discount), 0) || 0;
        return discount;
    };

    const getScheme = (date) => {
        const discount = data?.orderData?.filter(orders => orders.date === date).reduce((acc, order) => acc + parseFloat(order.schemeValue), 0) || 0;
        return discount;
    };

    const getIncentive = (date) => {
        const milk = getMilkTotal(date);
        const curd = getCurdTotal(date);
        const litters = milk + curd;
        const incentive = litters * data?.incentive;
        return incentive;
    };

    const getTransport = (date) => {
        const milk = getMilkTotal(date);
        const curd = getCurdTotal(date);
        const litters = milk + curd;
        const transport = litters * data?.transPort;
        return transport;
    };

    const getMargin = (date) => {
        const milk = getMilkTotal(date);
        const curd = getCurdTotal(date);
        const litters = milk + curd;
        const margin = litters * data?.margin;
        return margin;
    };

    useEffect(() => {
      getTotal();
    },[data]);

    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, `Ledger_${data?.dealer}_${month}.xlsx`);
    };

return (
    <>
        <Header />
        <Sidebar />

        <div className="content-wrapper">
            <div className="container-full">
                <section className="content">
                    <div className="box">
                    
                    <div className="box-header with-border">
                            <h4 className="box-title">Ledger Report</h4>
                            <p className="mb-0 box-subtitle">
                                Orders and Payments
                            </p>
                            
                        </div>
                      
                        <div className="box-body">
                        <div class="row mb-4"> <div class="space-between">
                    <div class="col-xxl-8 col-xl-8col-lg-8 col-md-6 col-12">
                   

                                <div>
                            		<h6 style={{fontWeight: '600'}}>{data?.dealer}</h6>
                                	<p>{data?.name}</p>
                                	<p>{data?.location}, {data?.route}</p>
                                	<p>{data?.phone}<br />{data?.email}</p>
                                	<p>{data?.address}</p>
								</div>
                                </div>
                    
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" align="right">
                        <input
                            type="month"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            className="form-control"
                            max={`${currentYear}-${String(currentMonth + 1).padStart(2, '0')}`}
                        /><br />
                    <button class="btn btn-outline" >Outstand <b>{(invoiceTotal-discountTotal-schemeTotal-transportTotal-marginTotal-paymentTotal).toFixed(2)}</b></button> <br />
                    <button onClick={downloadExcel} className="btn btn-primary mt-4"> Download Excel </button>
                    </div>
                    </div>
                    </div>
                    
                            <div className="table-responsive">
                                <table className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100" id="printableArea">
                                    <thead>
                                        <tr className="text-dark">
                                            <th>Date</th>
                                            <th>Invoice Total</th>
                                            <th>Milk (L)</th>
                                            <th>Curd (KG)</th>
                                            <th>Discount</th>
                                            <th>Scheme</th>
                                            <th>Incentive</th>
                                            <th>Transport</th>
                                            <th>C/F</th>
                                            <th>Received Payments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      {month && daysInMonth?.map((day) => (
                                        (getInvoiceTotal(formatShortDate(day)) > 0 || getPaymentTotal(formatShortDatePayment(day)) > 0) && (
                                        <tr key={day}>
                                          <td data-t="s">{formatFullDate(day)}</td>
                                          <td>{(getInvoiceTotal(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getMilkTotal(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getCurdTotal(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getDiscount(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getScheme(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getIncentive(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getTransport(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getMargin(formatShortDate(day))).toFixed(2)}</td>
                                          <td>{(getPaymentTotal(formatShortDatePayment(day))).toFixed(2)}</td>
                                            
                                        </tr>
                                         )
                                      ))}
                                      <tr>
                                        <th>Total</th>
                                        <th>{invoiceTotal.toFixed(2)}</th>
                                        <th>{milkTotal.toFixed(2)}</th>
                                        <th>{curdTotal.toFixed(2)}</th>
                                        <th>{discountTotal.toFixed(2)}</th>
                                        <th>{schemeTotal.toFixed(2)}</th>
                                        <th>{incentiveTotal.toFixed(2)}</th>
                                        <th>{transportTotal.toFixed(2)}</th>
                                        <th>{marginTotal.toFixed(2)}</th>
                                        <th>{paymentTotal.toFixed(2)}</th>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <Footer />
    </>
);
};
export default LedgerReport;